// extracted by mini-css-extract-plugin
export default {"iraUserInfo__cancel":"IraUserInfo_iraUserInfo__cancel__7Ph5C","iraUserInfo__save":"IraUserInfo_iraUserInfo__save__SCBnu"};